function init() {
  let menu = document.querySelector('.js-services-menu');
  let contentEle = document.querySelector('.js-services');
  let sections = document.querySelectorAll('.js-service-section');

  let positions;
  let active_section;
  let last_id = window.location.hash.slice(1);
  let content_top;

  const onresize = () => {
    const { top } = contentEle.getBoundingClientRect();
    content_top = contentEle.offsetTop;
    positions = [].map.call(sections, section => {
      return section.getBoundingClientRect().top - top;
    });
  }

  const onscroll = () => {
    const scroll_top = -window.scrollY;
    let i = sections.length;
    while (i--) {
      if (content_top + positions[i] + scroll_top < 160) {
        const section = sections[i];
        const { id } = section;
        if (id !== last_id) {
          active_section = id;
          last_id = id;
        }
        break;
      }
    }

    // update classes
    const link = menu.querySelector(`a[href="#${active_section}"`);
    if (link) {
      link.classList.add('is-active');
    }

    const links = menu.querySelectorAll(`a:not([href="#${active_section}"])`);
    for (let i = 0; i < links.length; i += 1) {
      links[i].classList.remove('is-active');
    }
  };

  onresize();
  window.addEventListener('scroll', onscroll, true);
  window.addEventListener('resize', onresize, true);

  // wait for fonts to load.
  setTimeout(onresize, 1000),
  setTimeout(onscroll, 5000)
}

init();
